/** @format */

import React, { useEffect, useState } from "react";
import { Helmet } from "fusion-plugin-react-helmet-async";
import { assetUrl } from "fusion-core";
import PortalCard from "../../components/dashboard/PortalCard";

const ContactPage = () => {
  const whatsApp = assetUrl("../../../../assets/icons/whatsapp-icon.svg");
  const sms = assetUrl("../../../../assets/icons/sms-icon.svg");
  const mainCss = assetUrl("../../../../styles/main.css");
  const css = assetUrl("../../../../styles/landing.css");

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if screen width is below 768px (commonly used for mobile detection)
    setIsMobile(window.innerWidth < 768);

    // Optional: Update on window resize
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardData = [
    {
      heading: "Whatsapp",
      text: "Speak to an expert from your phone via Whatsapp.",
      image: whatsApp,
      onClick: () => window.open("https://wa.me/message/AFHTP4P7CCZRL1"),
      button: "Open Whatsapp",
    },
    {
      heading: "SMS",
      text: isMobile
        ? "+447537453077"
        : "Send a text message to +447537453077 and our team will be in touch",
      image: sms,
      onClick: isMobile
        ? () => window.open("sms:+447537453077", "_self")
        : null, // Disable click for desktop
      button: "Send a text",
    },
  ];

  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
        <link rel="stylesheet" href={css} />
        <link rel="stylesheet" href={mainCss} />
      </Helmet>
      <h1 className="welcome-text">Get in touch with our team</h1>
      <div className="grid">
        {cardData.map((card, index) => (
          <PortalCard
            key={index}
            heading={card.heading}
            text={card.text}
            image={card.image}
            onClick={card.onClick}
            button={card.button}
            className="width-250"
            disabled={!isMobile && card.heading === "SMS"} // Disable button on desktop for SMS
          />
        ))}
      </div>
    </>
  );
};

export default ContactPage;
